export { default as Odeon } from "./Odeon";
export * from "./SharedTypes";

export type Result<T> = { ok: true; value: T } | { ok: false; error: My_Error };

export const Ok = <T>(data: T): Result<T> => {
    return { ok: true, value: data };
};

export const Err = (error: My_Error): Result<never> => {
    return { ok: false, error };
};

export type My_Error = {
    message: string;
};
